import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Scrollspy from 'react-scrollspy';

import { Rectangles, BurgerMenu, Close } from '../Icons';
import * as Utils from '../../utils';
import Button from '../../components/Button';
import { FRONT_COVER_ID } from '../../constants';

const Header = ({ donate, items, isVisible }) => {
  items = items.filter((e) => e?.id !== 'download-pdf');
  const headerRef = useRef();
  const [state, setState] = useState({
    activeItem: { ...items[0] },
    isOpen: false,
    scrollId: '',
  });
  const isOpen = !!state.isOpen;
  const activeItem = state.activeItem;
  const getItemById = (id) => {
    return items.find((e) => e?.id === id) || null;
  };
  const handleClick = (e) => {
    const scrollId = e.currentTarget.getAttribute('href').replace(/#/g, '');
    const activeItem = getItemById(scrollId);
    setState({
      ...state,
      activeItem,
      isOpen: false,
    });
  };
  const handleClickOutside = (e) => {
    if (!headerRef.current.contains(e.target) && state.isOpen) {
      setState({
        ...state,
        isOpen: false,
      });
    }
  };
  const handleScrollSpy = (el) => {
    const id = el?.id;

    if (!id) {
      return;
    }

    const activeItem = getItemById(id);

    setState({
      ...state,
      activeItem,
    });
  };
  const handleToggle = () => {
    setState({
      ...state,
      isOpen: !isOpen,
    });
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [state.isOpen]);

  return (
    <div
      className={classNames('header', { 'header--hidden': !isVisible }, { 'header--open': isOpen })}
      ref={headerRef}
    >
      <div className='header__belt'>
        <div className='header__branding'>
          <a
            href={`#${FRONT_COVER_ID}`}
            className='header__branding-link'
            onClick={(e) => handleClick(e)}
          >
            <Rectangles className='header__branding-icon' />
            <div className='header__branding-title'>
              President’s Update <span className='header__branding-year'>2022</span>
            </div>
          </a>
        </div>
        <div className='header__controls'>
          <Button
            className='header__controls-cta'
            theme='dark'
            href={`#${activeItem.id}`}
            onClick={(e) => handleClick(e)}
          >
            {Utils.stripHTML(activeItem?.title)}
          </Button>
          <Button className='header__controls-cta' theme='orange' href={donate} target='_blank'>
            Donate
          </Button>
        </div>
        <div className='header__menu'>
          <Button tag='button' className='header__menu-cta' onClick={handleToggle}>
            {!isOpen && <BurgerMenu className='header__menu-burger-icon' />}
            {isOpen && <Close className='header__menu-close-icon' />}
          </Button>
        </div>
      </div>
      <div className='header__nav'>
        <Scrollspy
          items={items?.map((item) => item?.id)}
          className='header__nav-list'
          currentClassName='header__nav-list-item--active'
          onUpdate={handleScrollSpy}
          offset={-100}
        >
          {items.map((item, index) => {
            return (
              <li className='header__nav-list-item' key={`header__nav-list-item-${index}`}>
                <Button
                  className='header__nav-list-item-link'
                  theme='dark'
                  dangerouslySetInnerHTML={{ __html: item?.title }}
                  href={`#${item.id}`}
                  onClick={(e) => handleClick(e)}
                />
              </li>
            );
          })}
        </Scrollspy>
      </div>
    </div>
  );
};

Header.propTypes = {
  donate: PropTypes.string,
  items: PropTypes.array,
  isVisible: PropTypes.bool,
};

export default Header;
